import MultiEditTableBody from './MultiEditTableBody';

export default MultiEditTableBody;
